import React, {useEffect} from "react";
import {Provider} from "react-redux";
import {BrowserRouter} from "react-router-dom";
import {ThemeSwitcherProvider} from "react-css-theme-switcher";
import store from "./store";
import history from "./history";
import Layouts from "./layouts";
import {THEME_CONFIG} from "./configs/AppConfig";
import "./lang";
import ServerAPIService from "./services/ServerAPIService";
import {CUSTOM_APP_NAME, CUSTOM_PRIMARY_BASE, CUSTOM_SECONDARY_BASE} from "./constants/AuthConstant";
import {notification} from "antd";

const themes = {
    light: `${process.env.PUBLIC_URL}/css/light-theme.css`,
};

function App() {
    ServerAPIService("GET", "auth", {clientSettings: true, limitedColumns: true}).then((resp) => {
        try {
            document.title = resp.data.dataMap.companyName;
            localStorage.setItem(CUSTOM_APP_NAME, resp.data.dataMap.companyName);
            localStorage.setItem(CUSTOM_PRIMARY_BASE, resp.data.dataMap.primaryColor);
            localStorage.setItem(CUSTOM_SECONDARY_BASE, resp.data.dataMap.secondaryColor);
        } catch (e) {
            notification.error({message: "Unable to connect to backoffice"});
        }
    });

    useEffect(() => {
    }, []);

    return (
        <div className="App">
            <Provider store={store}>
                <BrowserRouter history={history}>
                    <ThemeSwitcherProvider
                        themeMap={themes}
                        defaultTheme={THEME_CONFIG.currentTheme}
                        insertionPoint="styles-insertion-point">
                        <Layouts/>
                    </ThemeSwitcherProvider>
                </BrowserRouter>
            </Provider>
        </div>
    );
}

export default App;
